import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { config } from '../config/pages-config';
import { GeneralErrorComponent } from './shared/shared-components/general-error/general-error.component';
import { WhiteListDeepLinksGuard } from './common/authentication/white-list-deeplinks.guard';
import { ConfirmationComponent } from './shared/shared-components/confirmation/confirmation.component';
import { CenterHubComponent } from './shared/shared-components/center-hub/center-hub.component';
import { FormEditorComponent } from './shared/shared-components/form-editor/form-editor.component';
import { FormDetailsResolver } from './shared/services/form-details/form-details-resolver.service';
const routes: Routes = [
    {
        path: '',
        redirectTo: config.CenterHub.route,
        pathMatch: 'full',
    },
    {
      // Hub page
      path: config.CenterHub.name,
      component: CenterHubComponent,
      canActivate: [WhiteListDeepLinksGuard],
      pathMatch: 'full',
    },
    {
      // general error handleing page
      path: config.generalError.name,
      component: GeneralErrorComponent,
      canActivate: [WhiteListDeepLinksGuard],
      pathMatch: 'full',
    },
    {
      path: config.Confirmation.name,
      component: ConfirmationComponent,
      canActivate: [WhiteListDeepLinksGuard],
      pathMatch: 'full',
    },
    {
      path: config.FormEditor.name,
      component: FormEditorComponent,
      resolve: {formDetails: FormDetailsResolver},
      pathMatch: 'full',
    },

];
/** AppRoutingModule */
@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: false })],
    exports: [RouterModule],
})

export class AppRoutingModule { }
